import { privateAxios } from "../../../config/apiConfig";
import { getAllCategory } from "../Category/Action";
import {
  CREATE_SUBCATEGORY_FAILURE,
  CREATE_SUBCATEGORY_REQUEST,
  GET_ALL_SUBCATEGORY_SUCCESS,
  GET_ALL_SUBCATEGORY_REQUEST,
  GET_ALL_SUBCATEGORY_FAILURE,
  DELETE_SUBCATEGORY_REQUEST,
  DELETE_SUBCATEGORY_FAILURE,
  UPDATE_SUBCATEGORY_REQUEST,
  UPDATE_SUBCATEGORY_FAILURE,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllSubCategory = () => async (dispatch) => {
  dispatch({ type: GET_ALL_SUBCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/subCategories`);
    dispatch({ type: GET_ALL_SUBCATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_SUBCATEGORY_FAILURE, payload: error.message });
  }
};

export const createSubCategory = (subCategoryData, categoryId) => async (dispatch) => {
  dispatch({ type: CREATE_SUBCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/subCategory/category/${categoryId}`, subCategoryData);
    if (data.status === "SUCCESS") {
      dispatch(getAllCategory());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_SUBCATEGORY_FAILURE, payload: error.message });
  }
};


export const updateSubCategory = (subCategoryId, subCategoryData) => async (dispatch) => {
  dispatch({ type: UPDATE_SUBCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/subCategory/${subCategoryId}`,
      subCategoryData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllCategory());
      toast.success("SubSubCategory Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_SUBCATEGORY_FAILURE, payload: error.message });
  }
};

export const deleteSubCategory = (subCategoryId) => async (dispatch) => {
  dispatch({ type: DELETE_SUBCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/subCategory/${subCategoryId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllCategory());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_SUBCATEGORY_FAILURE, payload: error.message });
  }
};
